'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Components


// Actions


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _Breadcrumb = require('./Breadcrumb');

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _boardService = require('../../../element/board/boardService');

var boardService = _interopRequireWildcard(_boardService);

require('./BreadcrumbList.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        fetchBoard: function fetchBoard(argObj) {
            return dispatch(boardService.fetchBoard(argObj));
        }
    };
};

var CompleteBreadcrumbList = function CompleteBreadcrumbList(_ref) {
    var currentBoardId = _ref.currentBoardId,
        breadcrumbObj = _ref.breadcrumbObj,
        isMobileView = _ref.isMobileView;

    var breadcrumbs = isMobileView ? breadcrumbObj.path.slice(-2, -1) : breadcrumbObj.path;

    return _react2.default.createElement(
        'ul',
        null,
        breadcrumbs.map(function (breadcrumb, index) {
            return _react2.default.createElement(_Breadcrumb2.default, {
                key: breadcrumb,
                elementId: breadcrumb,
                currentBoardId: currentBoardId,
                index: index });
        })
    );
};

CompleteBreadcrumbList.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    breadcrumbObj: _propTypes2.default.object,
    isMobileView: _propTypes2.default.bool

};

var IncompleteList = function IncompleteList(_ref2) {
    var rootBoardId = _ref2.rootBoardId,
        currentBoardId = _ref2.currentBoardId;
    return _react2.default.createElement(
        'ul',
        null,
        rootBoardId ? _react2.default.createElement(_Breadcrumb2.default, { key: rootBoardId, elementId: rootBoardId, currentBoardId: currentBoardId, index: 0 }) : null,
        _react2.default.createElement(_Breadcrumb2.default, { key: currentBoardId, elementId: currentBoardId, currentBoardId: currentBoardId, index: 1 })
    );
};

IncompleteList.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    rootBoardId: _propTypes2.default.string
};

var BreadcrumbList = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(BreadcrumbList, _React$Component);

    function BreadcrumbList() {
        _classCallCheck(this, BreadcrumbList);

        return _possibleConstructorReturn(this, (BreadcrumbList.__proto__ || Object.getPrototypeOf(BreadcrumbList)).apply(this, arguments));
    }

    _createClass(BreadcrumbList, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var fetchBoard = nextProps.fetchBoard,
                breadcrumbObj = nextProps.breadcrumbObj;


            if (breadcrumbObj.complete) return;

            breadcrumbObj.missingElementIds.map(function (missingElementId) {
                return fetchBoard({ boardId: missingElementId, loadNextBoards: false, loadAncestors: true });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var complete = this.props.breadcrumbObj.complete;


            return _react2.default.createElement(
                'nav',
                { className: 'BreadcrumbList' },
                complete ? _react2.default.createElement(CompleteBreadcrumbList, this.props) : _react2.default.createElement(IncompleteList, this.props)
            );
        }
    }]);

    return BreadcrumbList;
}(_react2.default.Component)) || _class);
exports.default = BreadcrumbList;


BreadcrumbList.propTypes = {
    fetchBoard: _propTypes2.default.func,
    breadcrumbObj: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string.isRequired,
    rootBoardId: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/breadcrumbs/BreadcrumbList.js
// module id = 2164
// module chunks = 0